import { useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const Navbar = () => {
  const menuRef = useRef(null);
  const location = useLocation();
  const currentPath = location.pathname;
  const access = JSON.parse(Cookies.get("access"));

  const toggleDropdown = (event) => {
    event.preventDefault();
    const listItem = event.currentTarget.parentElement;
    listItem.classList.toggle("mm-active");
    const submenus = listItem.querySelectorAll("ul");
    submenus.forEach((submenu) => {
      submenu.classList.toggle("mm-collapse");
      submenu.classList.toggle("mm-show");
    });
  };

  const isActive = (path) => currentPath === path;
  const isInGroup = (paths) => {
    return paths.some((path) => currentPath.startsWith(path));
  };

  return (
    <>
      <hr />
      <div style={{ maxHeight: "100vh", overflowY: "auto" }}>
        <ul className="metismenu mb-5" id="menu" ref={menuRef}>
          <li className={isActive("/dashboard") ? "mm-active" : ""}>
            <Link to="/dashboard" className={location.pathname === "/Businessimpact" ? "nav-active" : ""}>
              <div className="parent-icon"><i className="bx bx-home-circle"></i></div>
              <div className="menu-title">Dashboard</div>
            </Link>
          </li>

          {/* Events Group */}
          {console.log(access, "access")}
          {
            (access.attend_event && access.attend_event === "1") &&
            <li className={`has-arrow ${isInGroup(["/EventsMenu"]) ? "mm-active" : ""}`}>
              <a href="#" onClick={toggleDropdown}>
                <div className="parent-icon"><i className="bx bx-chart"></i></div>
                <div className="menu-title">Events</div>
              </a>
              <ul className={`mm-collapse ${isInGroup(["/EventsMenu"]) ? "mm-show" : ""}`}>
                <li>
                  <Link to="/EventsMenu" className={isInGroup(["/EventsMenu"]) ? "nav-active" : ""}>
                    <i className="bx bx-right-arrow-alt"></i>Event
                  </Link>
                </li>
              </ul>
            </li>
          }

          <li className="menu-label">NMM</li>

          <li className={isInGroup(["/news"]) ? "mm-active" : ""}>
            <Link to="/news" className={isInGroup(["/news"]) ? "nav-active" : ""}>
              <div className="parent-icon"><i className="bx bx-chart"></i></div>
              <div className="menu-title">News</div>
            </Link>
          </li>

          <li className={isInGroup(["/Membership"]) ? "mm-active" : ""}>
            <Link to="/Membership" className={isInGroup(["/Membership"]) ? "nav-active" : ""}>
              <div className="parent-icon"><i className="bx bx-chart"></i></div>
              <div className="menu-title">Membership Plan</div>
            </Link>
          </li>

          {/* Business Impact */}
          <li className={`has-arrow ${isInGroup(["/Businessimpact", "/Business_impact","WithdrawalForm"]) ? "mm-active" : ""}`}>
            <a href="#" onClick={toggleDropdown}>
              <div className="parent-icon"><i className="bx bx-chart"></i></div>
              <div className="menu-title">Business Impact</div>
            </a>
            <ul className={`mm-collapse ${isInGroup(["/Businessimpact", "/Business_impact"]) ? "mm-show" : ""}`}>
              <li>
                <Link to="/Businessimpact" className={isInGroup(["/Businessimpact"]) ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>View Impact
                </Link>
              </li>
              <li>
                <Link to="/Business_impact" className={isInGroup(["/Business_impact"]) ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>Make Transaction
                </Link>
              </li>
              <li>
                <Link to="/WithdrawalForm" className={isInGroup(["/WithdrawalForm"]) ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>Withdrawal Request
                </Link>
              </li>
            </ul>
          </li>

          {/* Freight Request */}
          <li className={`has-arrow ${isInGroup(["/new_request", "/sent_request", "/receive_request", "/accept_request"]) ? "mm-active" : ""}`}>
            <a href="#" onClick={toggleDropdown}>
              <div className="parent-icon"><i className="bx bx-chart"></i></div>
              <div className="menu-title">Freight Request</div>
            </a>
            <ul className={`mm-collapse ${isInGroup(["/new_request", "/sent_request", "/receive_request", "/accept_request"]) ? "mm-show" : ""}`}>
              <li>
                <Link to="/new_request" className={isActive("/new_request") ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>New Request
                </Link>
              </li>
              <li>
                <Link to="/sent_request" className={isActive("/sent_request") ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>Request Sent
                </Link>
              </li>
              <li>
                <Link to="/receive_request" className={isActive("/receive_request") ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>Request Received
                </Link>
              </li>
              <li>
                <Link to="/accept_request" className={isActive("/accept_request") ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>Request Accept
                </Link>
              </li>
            </ul>
          </li>

          {/* User Profile Group */}
          <li className={`has-arrow ${isInGroup(["/profile", "/user", "/recentMember"]) ? "mm-active" : ""}`}>
            <a href="#" onClick={toggleDropdown}>
              <div className="parent-icon"><i className="bx bx-chart"></i></div>
              <div className="menu-title">User Profile</div>
            </a>
            <ul className={`mm-collapse ${isInGroup(["/profile", "/user", "/recentMember"]) ? "mm-show" : ""}`}>
              <li>
                <Link to="/profile" className={isInGroup(["/profile"]) ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>User Profile
                </Link>
              </li>
              <li>
                <Link to="/user" className={isInGroup(["/user"]) ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>User List
                </Link>
              </li>
              <li>
                <Link to="/recentMember" className={isInGroup(["/recentMember"]) ? "nav-active" : ""}>
                  <i className="bx bx-right-arrow-alt"></i>Recent Member
                </Link>
              </li>
            </ul>
          </li>

          <li className={isInGroup(["/invoicelist"]) ? "mm-active" : ""}>
            <Link to="/invoicelist" className={isInGroup(["/invoicelist"]) ? "nav-active" : ""}>
              <div className="parent-icon"><i className="bx bx-chart"></i></div>
              <div className="menu-title">Invoices</div>
            </Link>
          </li>

          <li className="menu-label">Community</li>

          <li className={isInGroup(["/Timeline"]) ? "mm-active" : ""}>
            <Link to="/Timeline" className={isInGroup(["/Timeline"]) ? "nav-active" : ""}>
              <div className="parent-icon"><i className="bx bx-chart"></i></div>
              <div className="menu-title">Timeline</div>
            </Link>
          </li>

          {(access.direct_chat && access.direct_chat === "1") &&
          <li className={isInGroup(["/chat"]) ? "mm-active" : ""}>
            <Link to="/chat" className={isInGroup(["/chat"]) ? "nav-active" : ""}>
              <div className="parent-icon"><i className="bx bx-chart"></i></div>
              <div className="menu-title">Chat</div>
            </Link>
          </li>
          }

          <li className={isInGroup(["/Help"]) ? "mm-active" : ""}>
            <Link to="/Help" className={isInGroup(["/Help"]) ? "nav-active" : ""}>
              <div className="parent-icon"><i className="bx bx-info-circle"></i></div>
              <div className="menu-title">Help</div>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
